// WEB.DIGITAL — scroll reveal, animated counters, testimonial cycler.
(function () {
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveal(root) {
    var els = (root || document).querySelectorAll('.wda-reveal:not(.wda-in)');
    if (reduceMotion || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('wda-in'); });
      return;
    }
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('wda-in');
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0, rootMargin: '0px' }
    );
    els.forEach(function (el, i) {
      el.style.transitionDelay = Math.min(i % 6, 4) * 60 + 'ms';
      io.observe(el);
    });
  }

  // Safety net: guarantees nothing stays invisible after a fast/instant scroll.
  var pending = false;
  function forceRevealVisible() {
    pending = false;
    document.querySelectorAll('.wda-reveal:not(.wda-in)').forEach(function (el) {
      if (el.getBoundingClientRect().top < window.innerHeight) el.classList.add('wda-in');
    });
  }
  window.addEventListener(
    'scroll',
    function () {
      if (pending) return;
      pending = true;
      requestAnimationFrame(forceRevealVisible);
    },
    { passive: true }
  );

  function animateCount(el) {
    if (el.dataset.wdaCounted) return;
    el.dataset.wdaCounted = '1';
    var target = parseFloat(el.getAttribute('data-count'));
    var suffix = el.getAttribute('data-suffix') || '';
    var prefix = el.getAttribute('data-prefix') || '';
    var decimals = (el.getAttribute('data-count').split('.')[1] || '').length;
    if (reduceMotion || isNaN(target)) {
      el.textContent = prefix + target + suffix;
      return;
    }
    var start = null;
    var duration = 1100;
    function step(ts) {
      if (start === null) start = ts;
      var progress = Math.min((ts - start) / duration, 1);
      var eased = 1 - Math.pow(1 - progress, 3);
      var value = (eased * target).toFixed(decimals);
      el.textContent = prefix + value + suffix;
      if (progress < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  function initCounters(root) {
    var els = (root || document).querySelectorAll('[data-count]');
    if (!els.length) return;
    if ('IntersectionObserver' in window) {
      var cio = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) animateCount(entry.target);
          });
        },
        { threshold: 0.6 }
      );
      els.forEach(function (el) { cio.observe(el); });
    } else {
      els.forEach(animateCount);
    }
  }

  function initTestimonials(root) {
    (root || document).querySelectorAll('[data-wda-testimonial]').forEach(function (block) {
      var quotes = [];
      try { quotes = JSON.parse(block.getAttribute('data-quotes') || '[]'); } catch (e) { quotes = []; }
      if (quotes.length < 2) return;
      var qi = 0;
      var textEl = block.querySelector('[data-wda-quote-text]');
      var whoEl = block.querySelector('[data-wda-quote-who]');
      var dots = block.querySelectorAll('[data-wda-quote-dot]');
      function render() {
        textEl.textContent = quotes[qi].q;
        whoEl.textContent = quotes[qi].w;
        dots.forEach(function (dot) {
          dot.classList.toggle('wda-quote-dot-active', Number(dot.getAttribute('data-index')) === qi);
        });
      }
      var timer = null;
      function startAuto() {
        clearInterval(timer);
        timer = setInterval(function () {
          qi = (qi + 1) % quotes.length;
          render();
        }, 5000);
      }
      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          qi = Number(dot.getAttribute('data-index'));
          render();
          startAuto();
        });
      });
      startAuto();
    });
  }

  function init(root) {
    initReveal(root);
    initCounters(root);
    initTestimonials(root);
  }

  document.addEventListener('DOMContentLoaded', function () { init(document); });
  // Re-init when the theme editor swaps a section in/out.
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
